package interviewprep.common

object InterviewPromptText {
    fun displayText(raw: String, title: String? = null): String {
        val normalized = raw.replace("\r\n", "\n").replace('\r', '\n')
        val markdownCleaned =
            normalized
                .lineSequence()
                .map(::cleanMarkdownLine)
                .filterNot { it == "---" }
                .joinToString("\n")
                .replace(Regex("""[ \t]+\n"""), "\n")
                .replace(Regex("""\n{3,}"""), "\n\n")
                .trim()
        return removeRepeatedTitle(markdownCleaned, title)
    }

    private fun cleanMarkdownLine(line: String): String =
        line.trim()
            .replace(Regex("""^#{1,6}\s*"""), "")
            .replace(Regex("""^\s*[-*]\s+"""), "")
            .replace("**", "")
            .replace("__", "")
            .replace("`", "")
            .trim()

    private fun removeRepeatedTitle(text: String, title: String?): String {
        val normalizedTitle = title?.trim()?.takeIf { it.isNotBlank() } ?: return text
        var withoutTitle = text
        while (withoutTitle.startsWith(normalizedTitle)) {
            withoutTitle = withoutTitle.removePrefix(normalizedTitle).trimStart(' ', '-', ':', '\n')
        }
        return withoutTitle.ifBlank { text }
    }
}
